import Categorias from './Categorias'

const ComponenteCategorias = () => {
  return (
    <>
      <Categorias />
      <Categorias />
      <Categorias />
    </>
  )
}

export default ComponenteCategorias
